import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { Search } from "lucide-react";

export default function TenantSearch() {
  const { slug } = useParams();
  const [q, setQ] = useState("");
  const [services, setServices] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/public/tenant/${slug}/services${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setServices(r.data));
    }, 200);
    return () => clearTimeout(t);
  }, [slug, q]);

  return (
    <div className="px-5 py-5 md:px-6 md:py-8" data-testid="tenant-search-page">
      <h1 className="brand-heading font-bold text-2xl md:text-3xl">Search</h1>
      <div className="mt-3 relative md:max-w-xl">
        <Search className="h-4 w-4 absolute left-4 top-1/2 -translate-y-1/2 brand-text-muted" />
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search services…" aria-label="Search services"
          data-testid="tenant-search-input"
          className="w-full pl-11 brand-surface brand-text brand-border border rounded-full px-4 py-3 text-base focus:outline-none" />
      </div>

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3 md:gap-4 mt-4 md:mt-6" data-testid="tenant-search-results">
        {services.map((s) => (
          <Link key={s.id} to={`/t/${slug}/service/${s.id}`} className="brand-card p-3 flex gap-3" data-testid={`tenant-search-result-${s.id}`}>
            <div className="h-16 w-16 rounded-xl brand-muted overflow-hidden flex-shrink-0">
              {s.images?.[0] && <img src={s.images[0]} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold leading-tight break-words">{s.name}</div>
              <div className="text-xs brand-text-muted line-clamp-1">{s.description}</div>
              <div className="text-sm font-bold mt-1">{formatINR(s.discount_price || s.price)}</div>
            </div>
          </Link>
        ))}
        {services.length === 0 && (
          <div className="text-sm brand-text-muted text-center py-10 md:col-span-2 xl:col-span-3 break-words">
            {q ? `No matches for "${q}"` : "No services yet."}
          </div>
        )}
      </div>
    </div>
  );
}
